import React from 'react';

import { OverlayLoading } from '@/components/shared/OverlayLoading';
import { Button } from '@/components/ui/button';
import { T_SwapDirection } from '@/hooks/PoolsToken/usePoolsTokenSwap';

interface I_ExecuteSwapButtonProps {
  onClick: () => void;
  disabled: boolean;
  isFullyConnected: boolean;
  isBusy: boolean;
  swapDirection: T_SwapDirection;
  buyState: {
    isApproving: boolean;
    isBuying: boolean;
  };
  sellState: {
    isApproving: boolean;
    isSelling: boolean;
  };
  t: (key: string) => string;
  openWalletConnect?: () => void;
}

export function ExecuteSwapButton({
  onClick,
  disabled,
  isFullyConnected,
  isBusy,
  swapDirection,
  buyState,
  sellState,
  t,
  openWalletConnect
}: I_ExecuteSwapButtonProps) {
  const getButtonText = () => {
    if (!isFullyConnected) return t('connectToSwap');
    if (isBusy) {
      if (buyState.isApproving || sellState.isApproving) {
        return t('approving');
      }
      if (buyState.isBuying || sellState.isSelling) {
        return swapDirection === 'usdc-to-token' ? t('buying') : t('selling');
      }
      return t('loading');
    }
    return t('swap');
  };

  const handleClick = () => {
    if (!isFullyConnected && openWalletConnect) {
      openWalletConnect();
    } else {
      onClick();
    }
  };

  const getOverlayText = () => {
    if (buyState.isApproving || sellState.isApproving) {
      return t('approving');
    }
    if (buyState.isBuying || sellState.isSelling) {
      return swapDirection === 'usdc-to-token' ? t('buying') : t('selling');
    }
    return t('loading');
  };

  return (
    <>
      <OverlayLoading isVisible={isBusy} text={getOverlayText()} />
      <Button
        variant="brand"
        onClick={handleClick}
        disabled={disabled && isFullyConnected}
      >
        {getButtonText()}
      </Button>
    </>
  );
}
